module.exports = __webpack_public_path__ + "static/media/Admin-8.e8103e86.png";